module.exports = __webpack_public_path__ + "static/media/N45.a4922aa6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N45.svg
// module id = 197
// module chunks = 0